import type { FC } from 'react'

import SubnavBase, * as Subnav from '@segment/matcha/recipes/Subnav'

import useScrollToAnchor from '@segment/utils/useScrollToAnchor'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import data from './data'

const copy = {
  title: `Customer Engagement Stack`,
}

const SCROLL_OFFSET = -144

const Subnavigation: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <SubnavBase aria-label={copy.title} label={copy.title}>
      {data.map((item) => {
        // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
        const scroll = useScrollToAnchor(item.id!, SCROLL_OFFSET)
        return `items` in item ? (
          <Subnav.Item key={item.label} label={item.label}>
            {item.items?.map((subItem) => {
              const scroll = useScrollToAnchor(subItem.id, SCROLL_OFFSET)
              return (
                <Subnav.Item
                  key={subItem.label}
                  href={getAbsoluteUrl(subItem.href, pageConfig)}
                  label={subItem.label}
                  onClick={(e) => {
                    e.preventDefault()
                    scroll()
                  }}
                />
              )
            })}
          </Subnav.Item>
        ) : (
          <Subnav.Item
            key={item.label}
            label={item.label}
            href={getAbsoluteUrl(item.href, pageConfig)}
            onClick={(e) => {
              e.preventDefault()
              scroll()
            }}
          />
        )
      })}
    </SubnavBase>
  )
}

export default Subnavigation
